_resetImpressionCount